import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledToggleSwitch = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .toggle-switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
    cursor: pointer;

    .toggle-switch-input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .toggle-switch-slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      transition: 0.3s;
      border-radius: 24px;

      &:before {
        position: absolute;
        content: "";
        height: 18px;
        width: 18px;
        left: 3px;
        bottom: 3px;
        background-color: white;
        transition: 0.3s;
        border-radius: 50%;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      }
    }

    .toggle-switch-input:checked + .toggle-switch-slider {
      background-color: #007bff;
    }

    .toggle-switch-input:checked + .toggle-switch-slider:before {
      transform: translateX(26px);
    }

    .toggle-switch-input:disabled + .toggle-switch-slider {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .toggle-switch-input:focus + .toggle-switch-slider {
      box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
    }
  }

  .toggle-switch-label {
    font-size: 14px;
    color: #333;
    user-select: none;
  }
`;

const ToggleSwitch = ({
  id,
  name,
  checked,
  onChange,
  disabled = false,
  label = "",
  className = "",
}) => {
  return (
    <StyledToggleSwitch className={`${className}`}>
      <label
        className="toggle-switch"
        htmlFor={id}
      >
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="toggle-switch-input"
        />
        <span className="toggle-switch-slider" />
      </label>
      {label && <span className="toggle-switch-label">{label}</span>}
    </StyledToggleSwitch>
  );
};

export default ToggleSwitch;

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
};
